import { call, put, select, takeLatest } from 'redux-saga/effects'
import {
  FetchingUserInformationAction,
  LogoutSuccessAction,
  UserReceivedAction,
  UserReceivedFailureAction
} from './auth-actions'
import selectIdToken from '../selectors/select-id-token'
import { FetchNoticesAction } from '../notices/notices-actions'
import { type CheckUserResponse, CompanyApi } from '../../api/company-api'
import { ApiUtil } from '../../api/api-utils'
import { type FetchUserSuccessPayload } from './auth-types'

// Note: disabling requiring explicit return types for saga generators
// (as the type is pretty complex and produces little value as explicit)
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function * fetchUserInformation() {
  const idToken: string = yield select(selectIdToken)

  const response: CheckUserResponse = yield call(CompanyApi.checkUser, idToken)
  if (response.succeeded) {
    const payload = response.payload

    if (payload.deleted) {
      console.warn('User is deleted -> forcing logout')
      yield put(LogoutSuccessAction())
    } else {
      const actionPayload: FetchUserSuccessPayload = {
        assignedToCompany: payload.assignedToCompany,
        ownCompany: payload.ownCompany != null
          ? ({
              id: payload.ownCompany.id,
              name: payload.ownCompany.name,
              users: payload.ownCompany.users.map(user => ({
                username: user.username
              }))
            })
          : undefined,
        user: {
          username: payload.user.username,
          systemAdmin: payload.user.systemAdmin
        }
      }

      if (response.payload.assignedToCompany) {
        // note: notices are accessible only if current user belongs to a company
        yield put(FetchNoticesAction())
      }
      yield put(UserReceivedAction(actionPayload))
    }
  } else {
    if (ApiUtil.shouldForceLogout(response)) {
      yield put(LogoutSuccessAction())
    }
    yield put(UserReceivedFailureAction({ errorKey: response.errorKey ?? 'auth.checkUserDefaultError' }))
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function * authSagas() {
  yield takeLatest(FetchingUserInformationAction, fetchUserInformation)
}
